/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

require('components/common/table-data/table-data');
const { dropMenu: dropMenuEvent } = require('components/config/event.json');
const tip = require('components/base/pop/tip');
const pop = require('components/base/pop/pop');

const ajaxHttp = require('appUtil/ajaxHttp');
const { apiPath } = require('appService/api');
const store = require('appVuex/store');
const calendar = require('components/common/data-calendar/data-calendar');
const { setBreadCrumb } = require('src/common/vuex/action/common');
const template = require('./reported-post.tpl');
require('./reported-post.scss');

const methMinxin = require('../community/methMixin');

const ReportedTopic = {
	mixins:[methMinxin],
	template,
	store,
	vuex: {
		actions: {
			setBreadCrumb,
		}
	},

	data() {
		return {
			thItems: ["举报用户","举报原因","举报时间", "发布用户","话题","内容摘要","发布时间","操作"],
			url: apiPath.community.reportedPost,//获取列表
			
			pageInitCt: 1,
			model:'post'
		}
	},
	ready(){

	},
	methods: {
		searchData() {
			this.searchVal = this.$refs.userInputbox? this.$refs.userInputbox.val(): "";
			this.$refs.tableData.query({
			}).fetch();
		},
		hidePost(id,idx,val,type){ //隐藏
        let that = this;
        let _val = val==0? 1: 0;
        let args = {
          'id': id,
          'model': type==1? this.model :'spotMark',
          'isVisible': _val
        };

        ajaxHttp(this.hideUrl, {
            type: "post",
            data: args
        }).then((res)=> {
            this.$refs.tableData.trItems[idx]["visible"] = _val;
        }).catch((res)=> {
            tip(res.message);
        })
      },
       deleteSure(){ //删除
        let _mod = this.model;
        let _type = this.tagObj['postType'];
        let args = {
          'model': _type==1? _mod : 'spotMark',
          'id':this.tagObj.id,
          'isDeleted':1
        };

        ajaxHttp(this.deleteUrl, {
            type: "post",
            data: args
        }).then((res)=> {
            tip(res.error || "删除成功");
			this.$refs.tableData.trItems.splice(this.tagObj.idx,1);
			this.$refs.tableData.resultData.total -= 1
            this.cancel();
        }).catch((res)=> {
            tip(res.message);
        })
  	},
		getQueryString(name) {
			if(typeof window.location.hash.split("?")[1] === 'undefined'){
				return '';
			}
			let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
			let r = window.location.hash.split("?")[1].match(reg);
			if (r != null) return unescape(r[2]); return null;
		}
	},
	components:{
		calendar,
		pop
	}
}

module.exports = ReportedTopic;



// WEBPACK FOOTER //
// ./src/appBackend/components/page/community/reported-post/reported-post.js